// extracted by mini-css-extract-plugin
export var emptyState = "_6p-d";
export var statCard = "_6p-c";
export var table = "_6p-0";
export var tableCell = "_6p-4";
export var tableCellClickable = "_6p-5 _6p-4";
export var tableCellDefault = "_6p-6 _6p-4";
export var tableCellEmpty = "_6p-8";
export var tableCellWithValue = "_6p-7";
export var tableContainer = "_6p-e";
export var tableHeaderWeight = "_6p-1";
export var tableHeaderZone = "_6p-2";
export var tableRowHeader = "_6p-3";
export var viewModeButton = "_6p-9";
export var viewModeButtonActive = "_6p-a _6p-9";
export var viewModeButtonInactive = "_6p-b _6p-9";